import { ShieldCheck } from "lucide-react";
import { getRoleDisplayName } from "../constants";

type UserRoleBadgeProps = {
  role: string;
  className?: string;
  variant?: "sidebar" | "signup";
};

export default function UserRoleBadge({
  role,
  className,
  variant = "sidebar",
}: UserRoleBadgeProps) {
  const isSignup = variant === "signup";

  return (
    <div
      className={[
        isSignup
          ? "inline-flex h-9 items-center justify-center gap-2 rounded-[6px] border border-[#1876F226] bg-[#1876F20F] px-4 text-[12px] font-semibold leading-[18px] text-[#1876F2]"
          : "inline-flex h-[20.5px] w-[104.21875px] items-center justify-center gap-1 rounded-[6px] bg-[#1876F20F] px-2 text-[11px] font-semibold leading-[16.5px] text-[#1876F2]",
        className ?? "",
      ].join(" ")}
    >
      <ShieldCheck className={isSignup ? "size-4 shrink-0" : "size-[12px] shrink-0"} />
      <span className="whitespace-nowrap">{getRoleDisplayName(role)}</span>
    </div>
  );
}

